/* eslint-disable */
/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Camera, Check, Edit, Image, IsClosed, IsOpen, Left, Plus, Times, View, Trash } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectMe, selectWork, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { List, Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';

import {
  addVehicleOption,
  deleteVehicleProperty,
  fetchVehicle,
  removeVehicleOption,
  setVehicleProperty,
} from '../../../Vehicles/actions';
import { ButtonBar } from '../../../../components/ButtonBar';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_OPTIONS,
  WS2_1_IMPORT_PHOTOS_COMMERCIAL,
  WS2_1_IMPORT_PHOTOS_PASSENGER,
  WS2_1_IMPRESSION_PHOTOS,
} from '../../../Vehicles/constants';
import { COLOR_BG_LIGHT, COLOR_PRIMARY_1, COLOR_SECONDARY_1 } from '../../../../vars';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { addDocument, deleteDocument } from '../../../Documents/actions';

import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { Cell as ActionCell } from '../Cell';
import { resizeAndRotate } from '../../../../utils/image';
import { getPropByName } from '../../../../utils/props';
import { getVehicleAge } from '../../../Vehicles/helpers';
import env from '../../../../env';
import { Dropdown } from '../../../../components/Dropdown';
import { selectUser } from '../../../Users/selectors';
import { isMobileDevice } from '../../../../utils/checkDevice';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';

const TASK_REMARK_TYPE = 'HOOI_NEW_task_inspection';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .modal-inner {
  }

  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .grid-container {
    width: 100%;
    display: grid;
    grid-template-columns: 49% 49%;

    .cell {
      margin: 5px;
      background-color: ${COLOR_BG_LIGHT};
      color: #808185;
      font-weight: 600;
      text-align: center;
      padding: 10px 0;
      border-radius: 0.375rem;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
  }

  .import-photo-wrapper {
    justify-content: space-between;
    height: 100%;
  }
  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .optionPhoto {
    position: fixed;
    background-color: black;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
  .options-list {
    .title {
      font-weight: 600;
      margin-top: 12px;
      font-size: 1.2rem;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 3px;
    }
  }
  .image-available {
    width: 32px;
    height: 32px;
    background-color: ${COLOR_SECONDARY_1};
    color: white;
    border-radius: 15px;
    text-align: center;
    margin-right: 3px;
    padding-top: 1px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
  }

  .tire_set {
    padding: 12px;
    background-color: #eee;

    > .box {
      max-width: 330px;
    }
    .tire-depth-container {
      width: 100%;
      .button {
        width: 60px;
        margin: 1px;
        align-self: stretch;
      }
    }

    .vehicle-property-loadable {
      max-width: 300px;
      &.loading {
        opacity: 0.2;
      }
    }
  }

  .attention-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid black;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }

  .import-img {
    width: 200px;
    height: 120px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  attention: false,
  regplate_code: '',
  date_last_maintenance: '',
  mileage_last_maintenance: '',
  // date_timing_belt_change: '',
  // mileage_timing_belt_change: '',
  mileage: '',
  attentionIncidentCost: '',
  attentionIncidentAcceptable: null,
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_interior_inspectionComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('attention_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );

    this.setState({
      ...comments,
      mileage: getPropByName(this.vehicle, 'mileage'),
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    ['date_last_maintenance', 'mileage_last_maintenance'].map(name => {
      let val = props.cell?.vehicle[name];
      if (val) {
        if (val.updatedAt != state[name + '_updatedAt']) {
          state[name + '_updatedAt'] = val.updatedAt;
          state[name] = val.propertyValue.value;
        }
      } else {
      }
    });
    return state;
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  get tripleCheckProps() {
    let props = [
      // 'has_instruction_book',
      // 'has_maintenance_book',
      // 'has_headrests',
      // 'has_hatrest',
      // 'has_charge_cable_230v',
      // 'has_charge_cable_380v',
      // 'has_charge_port',
    ];

    if (getVehicleAge(this.vehicle?.date_first_allowance) <= 7 && this.vehicle?.brand_name?.toLowerCase() == 'kia') {
      props.push('warranty_sticker');
    }

    return props;
  }

  requiredOption() {
    const reqProps = ['warranty_sticker'];
    const isReq = this.tripleCheckProps?.filter(type => reqProps?.includes(type));

    return isReq;
  }

  applyDisabled() {
    let isRequired = false;
    this.tripleCheckProps?.map(type => {
      if (this.requiredOption()?.includes(type) && this.vehicle[type] == 0) {
        isRequired = true;
      }
    });

    return isRequired;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_interior_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  renderPane(name, title, content) {
    return (
      <div className="pane">
        <HBox vCenter className="title" onClick={this.setStateFn({ [name]: !this.state[name] })}>
          {title}
          {name !== 'inspection' && <div>{this.state[name] ? <IsOpen /> : <IsClosed />} </div>}
        </HBox>
        {this.state[name] ? content : null}
      </div>
    );
  }

  renderFormField(name, type) {
    let ISO;
    if (type == 'date') {
      let date = this.vehicle[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }
    return (
      <FormField label={this.lbl('vehicle.property.' + name)} key={name}>
        <VehiclePropertyLoadable name={name}>
          {type == 'date' ? (
            <DatePicker
              dateFormat="dd-MM-yyyy"
              selected={this.vehicle[name] ? ISO : ''}
              onChange={val => {
                val = dayjs(val).format('DD-MM-YYYY');
                this.props.setProperty(name, val);
              }}
            />
          ) : (
            <Input
              type={type}
              value={this.state[name]}
              onChange={this.onInputChange.bind(this)}
              name={name}
              key={name}
              onBlur={() => {
                this.props.setProperty(name, this.state[name]);
              }}
            />
          )}
        </VehiclePropertyLoadable>
      </FormField>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <div className="title" key={index}>
          {this.lbl(`vehicle.options.${value.title}`)}
        </div>
      );

    let option = this.props.allOptions?.find(o => o.name.toLowerCase() == value.toLowerCase());

    // if (!option) debugger;

    let vehicleHasOption = this.vehicle.options?.find(o => o.id == option?.id);

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + value);

    let name = `vehicle-option-${option?.id}`;

    return (
      <HBox vCenter key={index} className={`option ${!option ? 'inactive' : ''} option-${option?.id}`}>
        <div>
          <VehiclePropertyLoadable name={name}>
            <Checkbox checked={checked} onChange={option ? () => this.toggleOption(option.id, !checked) : null}>
              {value}
            </Checkbox>
          </VehiclePropertyLoadable>
        </div>
        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className="pointer image-available"
              onClick={() => {
                let container = document.getElementsByClassName('modal-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  renderOptionPhotoDims,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: option?.id })} className="pointer">
              <Camera
                onClick={() =>
                  this.capture(
                    value,
                    this.callback(() => this.props.toggleOption(option.id, true)),
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </HBox>
    );
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;

    let document = this.vehicle.documents?.find(document => document.id == this.state.renderOptionPhoto);

    return (
      <div
        onClick={this.setStateFn({ renderOptionPhoto: null })}
        className="optionPhoto"
        style={{
          width: Math.ceil(this.state.renderOptionPhotoDims.width) + 'px',
          height: Math.ceil(this.state.renderOptionPhotoDims.height) + 'px',
          left: Math.ceil(this.state.renderOptionPhotoDims.x) + 'px',
          top: Math.ceil(this.state.renderOptionPhotoDims.y) + 'px',
        }}
      >
        <div className="img" style={{ backgroundImage: `url('${document.url}')` }}></div>
        <HBox>
          <Button onClick={this.setStateFn({ renderOptionPhoto: null })}>
            <Left /> {this.lbl('back')}
          </Button>
          <Button onClick={() => this.handlePhotoDelete(document.id)}>
            <Times />
            {this.lbl('delete')}
          </Button>
        </HBox>
      </div>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          {/* {this.renderModalBody()} */}
        </WithVehicle>
      </Modal>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    const required = this.requiredOption()?.includes(name) && val == 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
          </VehiclePropertyLoadable>
          {required && <RequireMark>*</RequireMark>}
        </div>

        {photo ? (
          <div
            className="pointer image-available"
            onClick={() => {
              let container = document.getElementsByClassName('modal-inner')[0];
              let renderOptionPhotoDims = container.getBoundingClientRect();
              this.setState({
                renderOptionPhoto: photo.id,
                renderOptionPhotoDims,
              });
            }}
          >
            <Camera />
          </div>
        ) : (
          <div onClick={this.setStateFn({ optionPhoto: name })} className="pointer">
            <VehiclePropertyLoadable name={name}>
              <Camera
                onClick={() =>
                  this.capture(
                    name,
                    this.callback(() => this.props.setProperty(name, 1)),
                  )
                }
              />
            </VehiclePropertyLoadable>
          </div>
        )}
      </HBox>
    );
  }

  renderTireBlock(n) {
    let name = 'tire_set_' + n;
    let value = this.propertyValue(name);
    if (!value) return null;

    let values = value.split(':');
    let i = 0;
    let mapped = {
      weather: values[i++],
      material: values[i++],
      size: values[i++],
      lf: values[i++],
      rf: values[i++],
      lb: values[i++],
      rb: values[i++],
    };

    const setValue = function(tName, tValue) {
      mapped[tName] = tValue;
      let value = '';
      this.props.setProperty(
        name,
        mapped.weather +
          ':' +
          mapped.material +
          ':' +
          mapped.size +
          ':' +
          mapped.lf +
          ':' +
          mapped.rf +
          ':' +
          mapped.lb +
          ':' +
          mapped.rb,
      );
    }.bind(this);

    return (
      <VBox className={`tire_set ${this.props.work ? 'disabled' : ''}`} key={`tire-block-${n}`}>
        <VehiclePropertyLoadable hideChildrenOnLoad={false} name={name}>
          {this.lbl('vehicle.property.tire_set.weather')}
          <ButtonBar>
            {['summer', 'all'].map(s => (
              <Button primary={mapped.weather == s} onClick={() => setValue('weather', s)} small key={s}>
                {this.lbl('vehicle.property.tire_set.weather.' + s)}
              </Button>
            ))}
          </ButtonBar>
          {this.lbl('vehicle.property.tire_set.material')}
          <ButtonBar>
            {['alu', 'steel', 'other'].map(name => (
              <Button primary={mapped.material == name} onClick={() => setValue('material', name)} small key={name}>
                {this.lbl('vehicle.property.tire_set.material.' + name)}
              </Button>
            ))}
          </ButtonBar>
          Inch:
          <HBox flexWrap center>
            {_.times(15, n => (
              <Button
                disabled={this.props.work}
                primary={12 + n == mapped.size}
                small
                key={n}
                onClick={() => setValue('size', 12 + n)}
              >
                {12 + n}
              </Button>
            ))}
          </HBox>
          <VBox>
            {['lf', 'rf', 'lb', 'rb'].map(name => (
              <VBox key={name}>
                {this.lbl('vehicle.property.tire_set.' + name)}
                <HBox flexWrap left className="tire-depth-container">
                  {_.times(10, n => (
                    <Button
                      primary={mapped[name] == n + 1}
                      small
                      disabled={this.props.work}
                      key={`${name}-${n + 1}`}
                      onClick={() => setValue(name, n + 1)}
                    >
                      {n + 1}
                    </Button>
                  ))}
                </HBox>
              </VBox>
            ))}
          </VBox>
        </VehiclePropertyLoadable>
        <HBox flexWrap gap={12}>
          {this.vehicle.documents
            .filter(doc => {
              return doc.type == 'photo_interior_tires_' + name;
            })
            .map(doc => {
              return this.renderImportPhoto(doc);
            })}
          <Button
            onClick={() => {
              this.capture('tires_' + name, this.props.refresh);
            }}
          >
            <Camera />
          </Button>
        </HBox>
      </VBox>
    );
  }

  addAttentionImage(index, isNewGroup = false) {
    this.capture('attention_' + index);
    if (isNewGroup) {
      this.props.setProperty(`attention_repaired_${index}`, 0);
      this.props.setProperty(`attention_displayed_${index}`, 1);
      this.props.setProperty(`attention_comment_${index}`, '');
    }
  }

  renderAttentionPhoto(document) {
    return (
      <div key={`attention-${document.id}`}>
        <div
          className="attention-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${document.url}')` }}
        ></div>
      </div>
    );
  }

  addImportImage(index, type, isNewGroup = false) {
    this.capture('import_' + index + ' ' + type);
  }

  renderImportPhoto(document) {
    return (
      <div key={`import-${document.id}`}>
        <div
          className="import-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${document.url}')` }}
        ></div>
      </div>
    );
  }

  renderImpressionPhoto(document) {
    return (
      <div key={`impression-${document.id}`}>
        <div
          className="import-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${document.url}')` }}
        ></div>
      </div>
    );
  }

  renderPlaceholderImage(vehiclePurpose, type) {
    return (
      <div key={type}>
        <div
          className="import-img"
          style={{
            backgroundImage: `url('/public/images/ws2_1_interior_defaults/${vehiclePurpose}/${type}.png')`,
          }}
        ></div>
      </div>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    return (
      <ActionCell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
          {this.props.workRemarks ? (
                                  <Loader small />
                                ) : (
                                  <KanbanVehicleRemarks
                                    key={'card'}
                                    readOnly
                                    taskName={TASK_REMARK_TYPE}
                                    kanbanBoardLabel={this.props.board?.label}
                                    vehicleId={this.vehicle.id}
                                    loggedUserId={this.props.loggedInUserId}
                                  />
                                )}
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={() => {
                    if (!vehicle.inspector_user_id || 1) {
                      //set inspector to current user
                      this.props.setProperty('inspector_user_id', this.props.me.id);
                      const inspectorUserName =
                        this.props.me.properties.find(prop => prop.name.name == 'fullname')?.value ??
                        `${this.props.me.properties.find(prop => prop.name.name == 'name')?.value}
                        ${this.props.me.properties.find(prop => prop.name.name == 'surname')?.value}`.trim();
                      this.props.setProperty('inspector_user_name', inspectorUserName);

                      if (!vehicle.inspection_location_company_id && vehicle.location_company_id) {
                        this.props.setProperty('inspection_location_company_id', vehicle.location_company_id);
                      }

                      if (vehicle.inspection_date) {
                        this.props.setProperty('inspection_date', dayjs().format('DD-MM-YYYY'));
                      }
                    }

                    this.to(`/boards/${this.props.board_id}/action-page/${vehicle?.id}`);
                  }}

                  //   window.innerWidth < 768
                  //     ? this.tofn(`/boards/action-page/${vehicle?.id}`)
                  //     : this.setStateFn(
                  //         { regplate_code: vehicle.regplate_code || '' },
                  //         this.tofn(`/boards/action-page/${vehicle?.id}`),
                  //       )
                  // }
                  // onClick={() => {
                  //   this.setState({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' });

                  //   //check if inspector is set
                  //   if (!this.vehicle.inspector_user_id || 1) {
                  //     //set inspector to current user
                  //     this.props.setProperty('inspector_user_id', this.props.me.id);
                  //     this.props.setProperty(
                  //       'inspector_user_name',
                  //       this.props.me.properties.find(prop => prop.name.name == 'fullname')?.value,
                  //     );

                  //     if (!this.vehicle.inspection_location_company_id && this.vehicle.location_company_id) {
                  //       this.props.setProperty('inspection_location_company_id', this.vehicle.location_company_id);
                  //     }

                  //     if (!this.vehicle.inspection_date) {
                  //       this.props.setProperty('inspection_date', dayjs().format('DD-MM-YYYY'));
                  //     }
                  //   }
                  // }}
                >
                  <View />
                </CellButton>
               
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  renderAttention() {
    const v = this.props.vehicle;

    if (!v) return null;

    let rows = [];

    for (let i = 0; i < 100; i++) {
      let photos = v.documents?.filter(d => {
        return d.type?.indexOf(`photo_interior_attention_${i}`) === 0;
      });

      if (!photos.length) continue;
      rows[i] = {
        index: i,
        photos,
      };
    }

    return (
      <VBox key="attentions">
        {rows.map(row => (
          <VBox>
            <HBox flexWrap left key={`attention-row-${row.index}`}>
              {row.photos.map(d => this.renderAttentionPhoto(d))}
              {row.photos.length < 4 && (
                <div className="thumb attention-img">
                  <VBox className="add" center vCenter onClick={() => this.addAttentionImage(row.index)}>
                    <Plus />
                  </VBox>
                </div>
              )}
            </HBox>
            <HBox>
              <FormField key={`attention-input-${row.index}`}>
                <Input
                  full
                  key={`attention-comment-${row.index}`}
                  name={`attention_comment_${row.index}`}
                  onChange={this.onCommentChange}
                  value={this.state[`attention_comment_${row.index}`]}
                  rightDecoration={
                    <>
                      <Button
                        small
                        onClick={() => {
                          this.props.setProperty(
                            `attention_comment_${row.index}`,
                            this.state[`attention_comment_${row.index}`],
                          );
                        }}
                      >
                        <Check />
                      </Button>
                      <Button
                        warning
                        small
                        onClick={() => {
                          this.props.deleteProperty(`attention_comment_${row.index}`);
                          this.setState({ [`attention_comment_${row.index}`]: '' });
                        }}
                      >
                        <Times />
                      </Button>
                    </>
                  }
                />
              </FormField>
            </HBox>
          </VBox>
        ))}
        <Button onClick={() => this.addAttentionImage(rows[rows.length - 1]?.index + 1 || 0, true)}>
          <Plus />
          {this.lbl('add')}
        </Button>
      </VBox>
    );
    return null;
  }

  renderImportPhotos() {
    const v = this.props.vehicle;

    if (!v) return null;
    if (!this.state.mileage) {
      this.setState({ mileage: getPropByName(v, 'mileage') });
    }

    let vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');

    vehiclePurpose = null;

    let defaults = [];
    let rows = [];

    if (vehiclePurpose === 'passenger') {
      defaults = WS2_1_IMPORT_PHOTOS_PASSENGER;
    }

    if (vehiclePurpose === 'commercial') {
      defaults = WS2_1_IMPORT_PHOTOS_COMMERCIAL;
    }

    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`photo_interior_import_0 ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox center className="import-photo-wrapper" onClick={() => this.addImportImage(0, row.placeholder)}>
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <FormField key={`import-input-0`} label={this.lbl('vehicle.import_photos.mileage_label')}>
          <Input
            full
            key={`mileage`}
            name={`mileage`}
            onChange={this.onCommentChange}
            value={this.state[`mileage`]}
            rightDecoration={
              <>
                <Button
                  small
                  disabled={this.props.workUpdate}
                  onClick={() => {
                    this.props.setProperty(`mileage`, this.state[`mileage`]);
                  }}
                >
                  {this.props.workUpdate ? <Loader small="true" /> : <Check />}
                </Button>
                <Button
                  warning
                  disabled={this.props.workUpdate}
                  small
                  onClick={() => {
                    this.props.deleteProperty(`mileage`);
                    this.setState({ [`mileage`]: '' });
                  }}
                >
                  {this.props.workUpdate ? <Loader small="true" /> : <Times />}
                </Button>
              </>
            }
          />
        </FormField>
      </>
    );
    return null;
  }

  renderImpressionPhotos() {
    const v = this.props.vehicle;

    if (!v) return null;

    let defaults = [];
    let rows = [];

    defaults = WS2_1_IMPRESSION_PHOTOS;

    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`photo_interior_import_0 ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.impression_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox center className="import-photo-wrapper" onClick={() => this.addImportImage(0, row.placeholder)}>
                      {this.renderPlaceholderImage('impression', row?.placeholder)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
    return null;
  }

  renderIncidentPhotos() {
    const v = this.props.vehicle;

    if (!v) return null;

    let type = `inspection_incident_${this.state.inspection_attention_photos}`;

    let photos = v.documents?.filter(d => {
      return d?.type == `photo_interior_${type}`;
    });

    return (
      <VBox>
        <HBox>
          <Button small onClick={this.setStateFn({ inspection_attention_photos: false })}>
            <Left />
          </Button>
          {photos.length < 5 ? (
            <Button small onClick={() => this.capture(type, this.props.refresh)}>
              {/* <Camera /> */}
            </Button>
          ) : null}
        </HBox>
        <div key="import_photos" className="grid-container">
          {photos.map(photo => this.renderImportPhoto(photo))}
        </div>
      </VBox>
    );
  }

  renderAttentionIncidents() {
    const v = this.props.vehicle;

    let parts = _.times(25, n => ({ value: n + 1, label: this.lbl('inspection.attention.part.' + (n + 1)) }));
    let types = _.times(10, n => ({ value: n + 1, label: this.lbl('inspection.attention.type.' + (n + 1)) }));
    let solutions = _.times(8, n => ({ value: n + 1, label: this.lbl('inspection.attention.solution.' + (n + 1)) }));

    if (!v) return;

    if (this.state.inspection_attention_photos) {
      return this.renderIncidentPhotos();
    }

    if (this.state.attentIncidentAdd) {
      return (
        <VBox>
          <Button small onClick={this.setStateFn({ attentIncidentAdd: false })}>
            <Left />
          </Button>
          <FormField label={this.lbl('inspection.attention.part')}>
            <Dropdown
              options={parts}
              value={parts.find(i => i.value == this.state.selectedAttentionPart)}
              onChange={({ value }) => this.setState({ selectedAttentionPart: value })}
            />
          </FormField>
          <FormField label={this.lbl('inspection.attention.type')}>
            <Dropdown
              options={types}
              value={types.find(i => i.value == this.state.selectedAttentionType)}
              onChange={({ value }) => this.setState({ selectedAttentionType: value })}
            />
          </FormField>
          <FormField label={this.lbl('inspection.attention.solution')}>
            <Dropdown
              options={solutions}
              value={solutions.find(i => i.value == this.state.selectedAttentionSolution)}
              onChange={({ value }) => this.setState({ selectedAttentionSolution: value })}
            />
          </FormField>
          <FormField label={this.lbl('inspection.attention.incident.cost')}>
            <Input
              value={this.state.attentionIncidentCost}
              onChange={evt =>
                this.setState({
                  attentionIncidentCost: evt.target.value.replace(/[^0-9]/g, ''),
                })
              }
            />
          </FormField>
          <FormField label={this.lbl('inspection.attention.incident.remarks')}>
            <Input
              value={this.state.attentionIncidentRemarks}
              onChange={evt =>
                this.setState({
                  attentionIncidentRemarks: evt.target.value.substr(0, 200),
                })
              }
            />
          </FormField>
          <hr />
          {this.lbl('inspection.attention.incident.acceptable')}
          <HBox center gap={12}>
            <Button
              primary={this.state.attentionIncidentAcceptable === true}
              onClick={this.setStateFn({ attentionIncidentAcceptable: true })}
            >
              {this.lbl('yes')}
            </Button>
            <Button
              primary={this.state.attentionIncidentAcceptable === false}
              onClick={this.setStateFn({ attentionIncidentAcceptable: false })}
            >
              {this.lbl('no')}
            </Button>
          </HBox>
          {this.state.attentionIncidentAcceptable === null ? null : (
            <Button onClick={this.saveIncident.bind(this)}>{this.lbl('save')}</Button>
          )}
        </VBox>
      );
    } else {
      return (
        <VBox>
          {Object.keys(v || {})
            .filter(key => key.indexOf('inspection_attention_incident') === 0)
            .map(key => (
              <HBox key={key} vCenter>
                {/* <div>
                  {v[key]?.part ? this.lbl('inspection.attention.part.' + v[key]?.part) : ''}&nbsp;:&nbsp;
                  {v[key]?.type ? this.lbl('inspection.attention.type.' + v[key]?.type) : ''}
                </div> */}
                <div>
                  <Button
                    small
                    onClick={() => {
                      let type = `inspection_incident_${v[key]?.id}`;

                      if (
                        v.documents?.filter(d => {
                          return d?.type == `photo_interior_${type}`;
                        }).length == 0
                      ) {
                        this.capture(type, this.props.refresh);
                      }
                      this.setState({ inspection_attention_photos: v[key]?.id || null });
                    }}
                  >
                    <Camera />
                  </Button>
                  <Button
                    small
                    onClick={() => {
                      this.setState({
                        attentIncidentAdd: true,
                        edit_attention_incident_id: v[key]?.id,
                        selectedAttentionPart: v[key]?.part,
                        selectedAttentionType: v[key]?.type,
                        selectedAttentionSolution: v[key]?.solution,
                        attentionIncidentCost: v[key]?.cost,
                        attentionIncidentRemarks: v[key]?.remarks,
                        attentionIncidentAcceptable: v[key]?.acceptable,
                      });
                    }}
                  >
                    <Edit />
                  </Button>
                  <Button small onClick={() => (confirm('delete?') ? this.props.deleteProperty(key) : null)}>
                    <Trash />
                  </Button>
                </div>
              </HBox>
            ))}
          <Button onClick={this.setStateFn({ attentIncidentAdd: true })}>+&nbsp;{this.lbl('add')}</Button>
        </VBox>
      );
    }
  }

  saveIncident() {
    const v = this.props.vehicle;

    let id =
      Object.keys(v)
        .filter(key => key.indexOf('inspection_attention_incident') === 0)
        .map(key => parseInt(key.split('_').pop(), 10))
        .sort()
        .pop() || 0;

    id = this.state.edit_attention_incident_id || id + 1;

    let incident = {
      id,
      part: this.state.selectedAttentionPart,
      type: this.state.selectedAttentionType,
      solution: this.state.selectedAttentionSolution,
      cost: this.state.attentionIncidentCost,
      remarks: (this.state.attentionIncidentRemarks || '').substr(0, 250),
      acceptable: this.state.attentionIncidentAcceptable,
    };

    this.props.setProperty('inspection_attention_incident_' + id, JSON.stringify(incident), () => {
      this.setState({
        attentIncidentAdd: false,
        selectedAttentionPart: null,
        selectedAttentionType: null,
        selectedAttentionSolution: null,
        attentionIncidentCost: '',
        attentionIncidentRemarks: null,
        attentionIncidentAcceptable: null,
      });
    });

    //update total amount
    let costs = Object.keys(v)
      .filter(key => key.indexOf('inspection_attention_incident') === 0)
      .map(key => parseInt(v[key]?.cost, 10) || 0);

    this.props.setProperty('inspection_attention_damage_cost_sum', _.sum(costs));
  }
}

HOOI_interior_inspectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    workUpdate: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    loggedInUser: selectUser(ownProps.loggedInUserId),
    me: selectMe(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      debugger;
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value, callback));
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    refresh() {
      dispatch(fetchVehicle(ownProps.cell.vehicle.id));
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.cell.vehicle.id, optionId, callback));
    },
    setProperty(name, value, callback) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value, callback));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.cell.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.cell.vehicle.id, 'vehicle', id, callback));
    },
    deleteProperty(name, callback) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_interior_inspection = compose(withConnect, withRouter)(HOOI_interior_inspectionComp);
